module.exports = __webpack_public_path__ + "img/1535350255.ecf1c06b.jpg";